import { getHandTypeLabel } from "backend/src/common/i18n";
import { HandType } from "backend/src/common/types/roomState";
import { Hand } from "components/Deck/hands/Hand";
import { useI18n } from "i18n/I18nProvider";
import { Modal } from "react-bulma-components";
import { setHandType } from "socket/events/setHandType";

import { store } from "store/store";

type ModalpsProps = {
  activeps: boolean;
  setActiveps: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CustomModalps: React.FC<ModalpsProps> = ({
  activeps,
  setActiveps,
}) => {
  const { locale, t } = useI18n();
  return (
    <Modal show={activeps} onClose={() => setActiveps(false)}>
      <Modal.Card>
        <Modal.Card.Header>
          <Modal.Card.Title>
            {t("waiting.modal.personal.title")}
          </Modal.Card.Title>
        </Modal.Card.Header>

        <Modal.Card.Body>
          {store.currentPlayer?.handType && (
            <div>
              {Object.values(HandType).map((type) => (
                <div key={type}>
                  <label>
                    <input
                      type="radio"
                      checked={type === store.currentPlayer?.handType}
                      onChange={() => {
                        setHandType(type);
                      }}
                      value={type}
                    />
                    {getHandTypeLabel(locale, type)}
                  </label>
                </div>
              ))}
              {store.currentPlayer?.handType && (
                <div
                  style={{
                    display: "flex",
                    padding: 20,
                    marginLeft: 50,
                  }}
                >
                  <Hand withCard type={store.currentPlayer.handType} />
                </div>
              )}
            </div>
          )}
        </Modal.Card.Body>
      </Modal.Card>
    </Modal>
  );
};
